











import { Component, Prop, Vue } from 'vue-property-decorator';
import { HeadingBlockDto } from '@/api';
import { CmsVariableResolver } from '@/util/CmsVariableResolver';

@Component
export default class HeadingBlock extends Vue {
  @Prop({required: true})
  public readonly model!: HeadingBlockDto;

  get title(): string {
    return CmsVariableResolver.resolve(this.model.title);
  }

  get subtitle(): string {
    return this.model.subtitle ? CmsVariableResolver.resolve(this.model.subtitle) : '';
  }
}
